import React from "react";
import { useTheme } from "@mui/material";

const ArrowProgressBar = ({ controlStages }) => {
  const theme = useTheme();
  const currentitem = controlStages.find((step) => step.is_ongoing);
  const currentitem_id = currentitem ? currentitem.item_id : 0;
  return (
    <div style={{ display: "flex", alignItems: "stretch", flexDirection: "row", height: "100px", width: "100%" }}>
      {controlStages.map((item, index) => {
        const isActive = item.item_id === currentitem_id;
        const isCompleted = item.item_id < currentitem_id;

        // Define colors based on state
        const itemColor = isCompleted
          ? theme.palette.primary.main
          : isActive
            ? theme.palette.secondary.main
            : theme.palette.tertiary.main;
        return (
          <div
            key={index}
            className={index === controlStages.length - 1 ? "finalcrumb" : "breadcrumb"}
            style={{
              "--bc": isActive ? theme.palette.text.primary : theme.palette.background.border,
              "--c": itemColor,
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              flexBasis: 0, // Allows equal distribution
              minWidth: "120px", // Set a minimum width
              minHeight: "100px", // Set a minimum height
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <span
              style={{
                fontSize: "clamp(10px, 2vw, 16px)", // Shrinks dynamically
                fontWeight: "bold",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "90%", // Prevents text from expanding too much
              }}
            >
              {item.item_label}
            </span>
            <span
              style={{
                fontSize: "clamp(8px, 1.5vw, 14px)", // Slightly smaller for secondary text
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "90%",
              }}
            >
              {item.item_value}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ArrowProgressBar;
